// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-sidebar-search-AddressInputAutocomplete-module__autocompleteItem:not(:last-child) {
    border-bottom: 1px lightgray solid;
}

@media (max-width: 44rem) {
    .src-sidebar-search-AddressInputAutocomplete-module__autocompleteItem:first-child {
        border-top: 1px lightgray solid;
    }
}

.src-sidebar-search-AddressInputAutocomplete-module__selectableItem {
    display: block;
    width: 100%;
    border: none;
    background: none;
    color: inherit;
    font: inherit;
    padding: 0;
    cursor: pointer;
    outline: inherit;
    overflow: hidden;
}

.src-sidebar-search-AddressInputAutocomplete-module__highlightedItem,
.src-sidebar-search-AddressInputAutocomplete-module__selectableItem:hover {
    background-color: #ececec;
}

.src-sidebar-search-AddressInputAutocomplete-module__selectableItem:active {
    background-color: #c6c6c6;
}

.src-sidebar-search-AddressInputAutocomplete-module__poiEntry {
    padding: 0.5em 0;
    display: flex;
    flex-direction: row;
    gap: 0.4rem;
    text-align: start;
    margin: 0.4rem 0.5rem;
}

.src-sidebar-search-AddressInputAutocomplete-module__poiEntryPrimaryText {
    font-weight: bold;
}

.src-sidebar-search-AddressInputAutocomplete-module__geocodingEntry {
    display: flex;
    flex-direction: column;
    text-align: start;
    margin: 0.4rem 0.5rem;
}

.src-sidebar-search-AddressInputAutocomplete-module__mainText {
    font-weight: bold;
}

.src-sidebar-search-AddressInputAutocomplete-module__secondaryText {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-size: small;
    color: #5b616a;
}
`, "",{"version":3,"sources":["webpack://./src/sidebar/search/AddressInputAutocomplete.module.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;AACtC;;AAEA;IACI;QACI,+BAA+B;IACnC;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB","sourcesContent":[".autocompleteItem:not(:last-child) {\n    border-bottom: 1px lightgray solid;\n}\n\n@media (max-width: 44rem) {\n    .autocompleteItem:first-child {\n        border-top: 1px lightgray solid;\n    }\n}\n\n.selectableItem {\n    display: block;\n    width: 100%;\n    border: none;\n    background: none;\n    color: inherit;\n    font: inherit;\n    padding: 0;\n    cursor: pointer;\n    outline: inherit;\n    overflow: hidden;\n}\n\n.highlightedItem,\n.selectableItem:hover {\n    background-color: #ececec;\n}\n\n.selectableItem:active {\n    background-color: #c6c6c6;\n}\n\n.poiEntry {\n    padding: 0.5em 0;\n    display: flex;\n    flex-direction: row;\n    gap: 0.4rem;\n    text-align: start;\n    margin: 0.4rem 0.5rem;\n}\n\n.poiEntryPrimaryText {\n    font-weight: bold;\n}\n\n.geocodingEntry {\n    display: flex;\n    flex-direction: column;\n    text-align: start;\n    margin: 0.4rem 0.5rem;\n}\n\n.mainText {\n    font-weight: bold;\n}\n\n.secondaryText {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    font-size: small;\n    color: #5b616a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"autocompleteItem": `src-sidebar-search-AddressInputAutocomplete-module__autocompleteItem`,
	"selectableItem": `src-sidebar-search-AddressInputAutocomplete-module__selectableItem`,
	"highlightedItem": `src-sidebar-search-AddressInputAutocomplete-module__highlightedItem`,
	"poiEntry": `src-sidebar-search-AddressInputAutocomplete-module__poiEntry`,
	"poiEntryPrimaryText": `src-sidebar-search-AddressInputAutocomplete-module__poiEntryPrimaryText`,
	"geocodingEntry": `src-sidebar-search-AddressInputAutocomplete-module__geocodingEntry`,
	"mainText": `src-sidebar-search-AddressInputAutocomplete-module__mainText`,
	"secondaryText": `src-sidebar-search-AddressInputAutocomplete-module__secondaryText`
};
export default ___CSS_LOADER_EXPORT___;
